import React from 'react';
import { DonutProgressProps } from './types';

export const DonutProgress: React.FC<DonutProgressProps> = ({
  progress,
  size = 440,
  strokeWidth = 100,
  color = '#FF6B6B',
  bgColor = '#FFAB91'
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - progress / 100);

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${size} ${size}`}
      style={{ 
        position: "absolute", 
        top: 0, 
        left: 0, 
        filter: "drop-shadow(0 8px 16px rgba(123, 63, 0, 0.3))",
      }}
    >
      <defs>
        <radialGradient id="donut3d" cx="50%" cy="50%" r="50%">
          <stop offset="60%" stopColor="#a86b2d" />
          <stop offset="85%" stopColor="#7B3F00" />
          <stop offset="100%" stopColor="#4a2511" />
        </radialGradient>
        <radialGradient id="bg3d" cx="50%" cy="50%" r="50%">
          <stop offset="60%" stopColor="#F5E1A4" />
          <stop offset="100%" stopColor="#E2C48D" />
        </radialGradient>
        <filter id="inner-shadow" x="-50%" y="-50%" width="200%" height="200%">
          <feOffset dx="0" dy="2" />
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feComposite in2="SourceAlpha" operator="in" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.25" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background ring with 3D gradient and soft inner shadow */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="url(#bg3d)"
        strokeWidth={strokeWidth}
        style={{ filter: "url(#inner-shadow)" }}
      />

      {/* Progress ring with 3D chocolate gradient */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="url(#donut3d)"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        style={{ 
          transition: "stroke-dashoffset 0.5s linear",
          filter: "drop-shadow(0 -2px 2px rgba(255,255,255,0.3)) drop-shadow(0 2px 2px rgba(0,0,0,0.2))"
        }}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
}; 